/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SuperadminRouteImport } from './routes/superadmin'
import { Route as PanelPreviewRouteImport } from './routes/panel-preview'
import { Route as MenuRouteImport } from './routes/menu'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DashboardPreviewRouteImport } from './routes/dashboard-preview'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthTablesRouteImport } from './routes/_auth/tables'
import { Route as AuthPaymentRouteImport } from './routes/_auth/payment'
import { Route as AuthDashboardRouteImport } from './routes/_auth/dashboard'
import { Route as AuthAdminRouteRouteImport } from './routes/_auth/admin/route'
import { Route as AuthAdminIndexRouteImport } from './routes/_auth/admin/index'
import { Route as LoyaltyRegisterOrgSlugRouteImport } from './routes/loyalty.register.$orgSlug'
import { Route as AuthAdminTerminalsRouteImport } from './routes/_auth/admin/terminals'
import { Route as AuthAdminStaffRouteImport } from './routes/_auth/admin/staff'
import { Route as AuthAdminQrMenuRouteImport } from './routes/_auth/admin/qr-menu'
import { Route as AuthAdminOrdersRouteImport } from './routes/_auth/admin/orders'
import { Route as AuthAdminMenuRouteImport } from './routes/_auth/admin/menu'
import { Route as AuthAdminLoyaltyRouteImport } from './routes/_auth/admin/loyalty'
import { Route as AuthAdminFloorPlanRouteImport } from './routes/_auth/admin/floor-plan'

const SuperadminRoute = SuperadminRouteImport.update({
  id: '/superadmin',
  path: '/superadmin',
  getParentRoute: () => rootRouteImport,
} as any)
const PanelPreviewRoute = PanelPreviewRouteImport.update({
  id: '/panel-preview',
  path: '/panel-preview',
  getParentRoute: () => rootRouteImport,
} as any)
const MenuRoute = MenuRouteImport.update({
  id: '/menu',
  path: '/menu',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardPreviewRoute = DashboardPreviewRouteImport.update({
  id: '/dashboard-preview',
  path: '/dashboard-preview',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthTablesRoute = AuthTablesRouteImport.update({
  id: '/tables',
  path: '/tables',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthPaymentRoute = AuthPaymentRouteImport.update({
  id: '/payment',
  path: '/payment',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthDashboardRoute = AuthDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthAdminRouteRoute = AuthAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthAdminIndexRoute = AuthAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAdminRouteRoute,
} as any)
const LoyaltyRegisterOrgSlugRoute = LoyaltyRegisterOrgSlugRouteImport.update({
  id: '/loyalty/register/$orgSlug',
  path: '/loyalty/register/$orgSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAdminTerminalsRoute = AuthAdminTerminalsRouteImport.update({
  id: '/terminals',
  path: '/terminals',
  getParentRoute: () => AuthAdminRouteRoute,
} as any)
const AuthAdminStaffRoute = AuthAdminStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => AuthAdminRouteRoute,
} as any)
const AuthAdminQrMenuRoute = AuthAdminQrMenuRouteImport.update({
  id: '/qr-menu',
  path: '/qr-menu',
  getParentRoute: () => AuthAdminRouteRoute,
} as any)
const AuthAdminOrdersRoute = AuthAdminOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AuthAdminRouteRoute,
} as any)
const AuthAdminMenuRoute = AuthAdminMenuRouteImport.update({
  id: '/menu',
  path: '/menu',
  getParentRoute: () => AuthAdminRouteRoute,
} as any)
const AuthAdminLoyaltyRoute = AuthAdminLoyaltyRouteImport.update({
  id: '/loyalty',
  path: '/loyalty',
  getParentRoute: () => AuthAdminRouteRoute,
} as any)
const AuthAdminFloorPlanRoute = AuthAdminFloorPlanRouteImport.update({
  id: '/floor-plan',
  path: '/floor-plan',
  getParentRoute: () => AuthAdminRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard-preview': typeof DashboardPreviewRoute
  '/login': typeof LoginRoute
  '/menu': typeof MenuRoute
  '/panel-preview': typeof PanelPreviewRoute
  '/superadmin': typeof SuperadminRoute
  '/admin': typeof AuthAdminRouteRouteWithChildren
  '/dashboard': typeof AuthDashboardRoute
  '/payment': typeof AuthPaymentRoute
  '/tables': typeof AuthTablesRoute
  '/admin/floor-plan': typeof AuthAdminFloorPlanRoute
  '/admin/loyalty': typeof AuthAdminLoyaltyRoute
  '/admin/menu': typeof AuthAdminMenuRoute
  '/admin/orders': typeof AuthAdminOrdersRoute
  '/admin/qr-menu': typeof AuthAdminQrMenuRoute
  '/admin/staff': typeof AuthAdminStaffRoute
  '/admin/terminals': typeof AuthAdminTerminalsRoute
  '/loyalty/register/$orgSlug': typeof LoyaltyRegisterOrgSlugRoute
  '/admin/': typeof AuthAdminIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard-preview': typeof DashboardPreviewRoute
  '/login': typeof LoginRoute
  '/menu': typeof MenuRoute
  '/panel-preview': typeof PanelPreviewRoute
  '/superadmin': typeof SuperadminRoute
  '/dashboard': typeof AuthDashboardRoute
  '/payment': typeof AuthPaymentRoute
  '/tables': typeof AuthTablesRoute
  '/admin/floor-plan': typeof AuthAdminFloorPlanRoute
  '/admin/loyalty': typeof AuthAdminLoyaltyRoute
  '/admin/menu': typeof AuthAdminMenuRoute
  '/admin/orders': typeof AuthAdminOrdersRoute
  '/admin/qr-menu': typeof AuthAdminQrMenuRoute
  '/admin/staff': typeof AuthAdminStaffRoute
  '/admin/terminals': typeof AuthAdminTerminalsRoute
  '/loyalty/register/$orgSlug': typeof LoyaltyRegisterOrgSlugRoute
  '/admin': typeof AuthAdminIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteRouteWithChildren
  '/dashboard-preview': typeof DashboardPreviewRoute
  '/login': typeof LoginRoute
  '/menu': typeof MenuRoute
  '/panel-preview': typeof PanelPreviewRoute
  '/superadmin': typeof SuperadminRoute
  '/_auth/admin': typeof AuthAdminRouteRouteWithChildren
  '/_auth/dashboard': typeof AuthDashboardRoute
  '/_auth/payment': typeof AuthPaymentRoute
  '/_auth/tables': typeof AuthTablesRoute
  '/_auth/admin/floor-plan': typeof AuthAdminFloorPlanRoute
  '/_auth/admin/loyalty': typeof AuthAdminLoyaltyRoute
  '/_auth/admin/menu': typeof AuthAdminMenuRoute
  '/_auth/admin/orders': typeof AuthAdminOrdersRoute
  '/_auth/admin/qr-menu': typeof AuthAdminQrMenuRoute
  '/_auth/admin/staff': typeof AuthAdminStaffRoute
  '/_auth/admin/terminals': typeof AuthAdminTerminalsRoute
  '/loyalty/register/$orgSlug': typeof LoyaltyRegisterOrgSlugRoute
  '/_auth/admin/': typeof AuthAdminIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard-preview'
    | '/login'
    | '/menu'
    | '/panel-preview'
    | '/superadmin'
    | '/admin'
    | '/dashboard'
    | '/payment'
    | '/tables'
    | '/admin/floor-plan'
    | '/admin/loyalty'
    | '/admin/menu'
    | '/admin/orders'
    | '/admin/qr-menu'
    | '/admin/staff'
    | '/admin/terminals'
    | '/loyalty/register/$orgSlug'
    | '/admin/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard-preview'
    | '/login'
    | '/menu'
    | '/panel-preview'
    | '/superadmin'
    | '/dashboard'
    | '/payment'
    | '/tables'
    | '/admin/floor-plan'
    | '/admin/loyalty'
    | '/admin/menu'
    | '/admin/orders'
    | '/admin/qr-menu'
    | '/admin/staff'
    | '/admin/terminals'
    | '/loyalty/register/$orgSlug'
    | '/admin'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/dashboard-preview'
    | '/login'
    | '/menu'
    | '/panel-preview'
    | '/superadmin'
    | '/_auth/admin'
    | '/_auth/dashboard'
    | '/_auth/payment'
    | '/_auth/tables'
    | '/_auth/admin/floor-plan'
    | '/_auth/admin/loyalty'
    | '/_auth/admin/menu'
    | '/_auth/admin/orders'
    | '/_auth/admin/qr-menu'
    | '/_auth/admin/staff'
    | '/_auth/admin/terminals'
    | '/loyalty/register/$orgSlug'
    | '/_auth/admin/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  DashboardPreviewRoute: typeof DashboardPreviewRoute
  LoginRoute: typeof LoginRoute
  MenuRoute: typeof MenuRoute
  PanelPreviewRoute: typeof PanelPreviewRoute
  SuperadminRoute: typeof SuperadminRoute
  LoyaltyRegisterOrgSlugRoute: typeof LoyaltyRegisterOrgSlugRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/superadmin': {
      id: '/superadmin'
      path: '/superadmin'
      fullPath: '/superadmin'
      preLoaderRoute: typeof SuperadminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/panel-preview': {
      id: '/panel-preview'
      path: '/panel-preview'
      fullPath: '/panel-preview'
      preLoaderRoute: typeof PanelPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/menu': {
      id: '/menu'
      path: '/menu'
      fullPath: '/menu'
      preLoaderRoute: typeof MenuRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard-preview': {
      id: '/dashboard-preview'
      path: '/dashboard-preview'
      fullPath: '/dashboard-preview'
      preLoaderRoute: typeof DashboardPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/tables': {
      id: '/_auth/tables'
      path: '/tables'
      fullPath: '/tables'
      preLoaderRoute: typeof AuthTablesRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/payment': {
      id: '/_auth/payment'
      path: '/payment'
      fullPath: '/payment'
      preLoaderRoute: typeof AuthPaymentRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/dashboard': {
      id: '/_auth/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/admin': {
      id: '/_auth/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthAdminRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/admin/': {
      id: '/_auth/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthAdminIndexRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/loyalty/register/$orgSlug': {
      id: '/loyalty/register/$orgSlug'
      path: '/loyalty/register/$orgSlug'
      fullPath: '/loyalty/register/$orgSlug'
      preLoaderRoute: typeof LoyaltyRegisterOrgSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/admin/terminals': {
      id: '/_auth/admin/terminals'
      path: '/terminals'
      fullPath: '/admin/terminals'
      preLoaderRoute: typeof AuthAdminTerminalsRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/staff': {
      id: '/_auth/admin/staff'
      path: '/staff'
      fullPath: '/admin/staff'
      preLoaderRoute: typeof AuthAdminStaffRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/qr-menu': {
      id: '/_auth/admin/qr-menu'
      path: '/qr-menu'
      fullPath: '/admin/qr-menu'
      preLoaderRoute: typeof AuthAdminQrMenuRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/orders': {
      id: '/_auth/admin/orders'
      path: '/orders'
      fullPath: '/admin/orders'
      preLoaderRoute: typeof AuthAdminOrdersRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/menu': {
      id: '/_auth/admin/menu'
      path: '/menu'
      fullPath: '/admin/menu'
      preLoaderRoute: typeof AuthAdminMenuRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/loyalty': {
      id: '/_auth/admin/loyalty'
      path: '/loyalty'
      fullPath: '/admin/loyalty'
      preLoaderRoute: typeof AuthAdminLoyaltyRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
    '/_auth/admin/floor-plan': {
      id: '/_auth/admin/floor-plan'
      path: '/floor-plan'
      fullPath: '/admin/floor-plan'
      preLoaderRoute: typeof AuthAdminFloorPlanRouteImport
      parentRoute: typeof AuthAdminRouteRoute
    }
  }
}

interface AuthAdminRouteRouteChildren {
  AuthAdminFloorPlanRoute: typeof AuthAdminFloorPlanRoute
  AuthAdminLoyaltyRoute: typeof AuthAdminLoyaltyRoute
  AuthAdminMenuRoute: typeof AuthAdminMenuRoute
  AuthAdminOrdersRoute: typeof AuthAdminOrdersRoute
  AuthAdminQrMenuRoute: typeof AuthAdminQrMenuRoute
  AuthAdminStaffRoute: typeof AuthAdminStaffRoute
  AuthAdminTerminalsRoute: typeof AuthAdminTerminalsRoute
  AuthAdminIndexRoute: typeof AuthAdminIndexRoute
}

const AuthAdminRouteRouteChildren: AuthAdminRouteRouteChildren = {
  AuthAdminFloorPlanRoute: AuthAdminFloorPlanRoute,
  AuthAdminLoyaltyRoute: AuthAdminLoyaltyRoute,
  AuthAdminMenuRoute: AuthAdminMenuRoute,
  AuthAdminOrdersRoute: AuthAdminOrdersRoute,
  AuthAdminQrMenuRoute: AuthAdminQrMenuRoute,
  AuthAdminStaffRoute: AuthAdminStaffRoute,
  AuthAdminTerminalsRoute: AuthAdminTerminalsRoute,
  AuthAdminIndexRoute: AuthAdminIndexRoute,
}

const AuthAdminRouteRouteWithChildren = AuthAdminRouteRoute._addFileChildren(
  AuthAdminRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthAdminRouteRoute: typeof AuthAdminRouteRouteWithChildren
  AuthDashboardRoute: typeof AuthDashboardRoute
  AuthPaymentRoute: typeof AuthPaymentRoute
  AuthTablesRoute: typeof AuthTablesRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthAdminRouteRoute: AuthAdminRouteRouteWithChildren,
  AuthDashboardRoute: AuthDashboardRoute,
  AuthPaymentRoute: AuthPaymentRoute,
  AuthTablesRoute: AuthTablesRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  DashboardPreviewRoute: DashboardPreviewRoute,
  LoginRoute: LoginRoute,
  MenuRoute: MenuRoute,
  PanelPreviewRoute: PanelPreviewRoute,
  SuperadminRoute: SuperadminRoute,
  LoyaltyRegisterOrgSlugRoute: LoyaltyRegisterOrgSlugRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
